import { configureStore } from '@reduxjs/toolkit';
import userDetailsReducer from './slices/userDetailslice';
import staffCountSlice from './slices/staffCountSlice';
import validatePendingStaffSlice from './slices/validatePendingStaffSlice';
import sideMenuDetailsReducer from './slices/sideMenuSlice';
import roleDetailsReducer from './slices/rolesSlice';
import staffListSlice from './slices/staffListSlice';
import loginReducer from './slices/loginSlice';
import applicationDetailsReducer from './slices/applicationSlice'
import consentDetailsSlice from './slices/consentSlice';
import userOnboardDetailsSlice from './slices/userOnboardSlice';
export const store = configureStore({
  reducer: {
    applicationDetails: applicationDetailsReducer,
    userDetails: userDetailsReducer,
    roleDetails: roleDetailsReducer,
    staffCount: staffCountSlice,
    validatePendingStaffData: validatePendingStaffSlice,
    staffListData: staffListSlice,
    sideMenuDetails: sideMenuDetailsReducer,
    loginDetails: loginReducer,
    consentDetails: consentDetailsSlice,
    userOnboardingJsonDetails:userOnboardDetailsSlice
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
